import React, { useEffect } from "react";
import styled from "styled-components";
import { AdminGroupRow } from "../components";
import { useSeasonDivisionContext } from "../context/season_division_context";

const AdminListView = ({ divisionId }) => {
  const {
    seasonGrpInProgress,
    seasonGrpError,
    divisionPlayers,
    divisionId: divId,
    updateDivisionId,
  } = useSeasonDivisionContext();

  useEffect(() => {
    updateDivisionId(divisionId);
    // eslint-disable-next-line
  }, [divisionId]);

  if (divId === null || seasonGrpInProgress) {
    return <div>Loading...</div>;
  }

  if (seasonGrpError) {
    return <div>Ha ocurrido un error cargando la clasificación</div>;
  }

  const lastPosition = divisionPlayers.length;

  return (
    <Wrapper>
      <div className="row header">
        <div className="x1">#</div>
        <div className="x3">Jugador</div>
        <div className="x2">Puntos</div>
        <div className="x2">
          Series
          <br />
          V-D
        </div>
        <div className="x2">
          Mapas
          <br />
          V-D
        </div>
        <div className="x3">Partidas</div>
      </div>
      <hr />
      {divisionPlayers.map((player) => {
        console.log("Player:");
        console.log(player);
        return (
          <AdminGroupRow
            key={`GroupRow-${player.registration_id}-${player.position}`}
            {...player}
            lastPosition={lastPosition}
          />
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
  }

  hr {
    border-color: var(--clr-grey-10);
  }
  .x1 {
    width: 2rem;
    margin: 1rem;
    display: flex;
    justify-content: center;
  }

  .x2 {
    width: 6rem;
    margin: 1rem;
    display: flex;
    justify-content: center;
  }

  .x3 {
    width: 28rem;
    margin: 1rem;
  }

  .x4 {
    width: 56rem;
    margin: 1rem;
  }

  .header {
    font-weight: bold;
  }
`;

export default AdminListView;
